// Polyfills //
import "@babel/polyfill";
import "Js/closest";
import "Js/forEach";
import "Js/searchParams";

// Import assets JS //
import OverflowScroll from "Js/overflowScroll";
import Translations from  "Js/translations";

// Import component JS modules //
import Alerts from "Components/alerts/alerts";
import BannerCarousel from "Components/banners/banners";
import Carousel from "Components/carousel/carousel";
import Dropdown from "Components/dropdown/dropdown";
import EntryFilters from "Components/filters/filters";
import FindAnOfficeSearch from "Components/find-an-office-search/find-an-office-search";
import Forms from "Components/forms/forms";
import Image from "Components/image/image";
import Header from "Components/header/header";
import Modal from "Components/modal/modal";
import OccupationSearch from "Components/occupation-search/occupation-search";
import Search from "Components/search/search";
import Sharey from "Components/sharey/sharey";
import Video from "Components/video/video";

// Import Other JS //
import "Components/office-locator/office-locator.js";


// Initalise componet JS modules //
document.addEventListener("DOMContentLoaded", () => {
    // Alerts //
    const alerts = new Alerts();
    alerts.init();

    // Carousel //
    const bannerCarousel = new BannerCarousel();
    bannerCarousel.init();

    // Carousel //
    const carousel = new Carousel();
    carousel.init();

    // Dropdown //
    const dropdown = new Dropdown();
    dropdown.init();

    // Entry Filters //
    const entryFilters = new EntryFilters();
    entryFilters.init();

    // Occupation Search //
    const findAnOfficeSearch = new FindAnOfficeSearch();
    findAnOfficeSearch.init();

    // Forms //
    const forms = new Forms();
    forms.init();

    // Header //
    const header = new Header();
    header.init();

    // Lazy Load Images //
    const images = new Image();
    images.lazyLoad();

    // Modal //
    const modals = new Modal();
    modals.init();

    // Occupation Search //
    const occupationSearch = new OccupationSearch();
    occupationSearch.init();

    // Overflow Scroll //
    const overflowScroll = new OverflowScroll();
    overflowScroll.init();

    // Search //
    const search = new Search();
    search.init();

    // Sharey //
    const sharey = new Sharey();
    sharey.init();

    // Translations //
    const translations = new Translations();
    translations.init();

    // Videos //
    const videos = new Video();
    videos.lazyLoad();
});



// WEBPACK FOOTER //
// ./components.js